// store/loadingStore.ts
import { create } from 'zustand';

interface LoadingState {
    isLoading: boolean;
    loadingText: string;
    loadingCount: number;
    actions: {
        startLoading: (text?: string) => void;
        stopLoading: () => void;
        setLoadingText: (text: string) => void;
    };
}

const initialState = {
    isLoading: false,
    loadingText: '로딩 중...',
    loadingCount: 0,
};

export const useLoadingStore = create<LoadingState>((set) => ({
    ...initialState,

    actions: {
        startLoading: (text) => {
            set((state) => ({
                isLoading: true,
                loadingText: text || '로딩 중...',
                loadingCount: state.loadingCount + 1,
            }));
        },

        stopLoading: () => {
            set((state) => {
                const newCount = Math.max(0, state.loadingCount - 1);
                return {
                    loadingCount: newCount,
                    isLoading: newCount > 0,
                    loadingText: newCount > 0 ? state.loadingText : initialState.loadingText,
                };
            });
        },

        setLoadingText: (text) => {
            set({ loadingText: text });
        },
    },
}));

// 간편 사용을 위한 Hook
export const useLoading = () => {
    const isLoading = useLoadingStore((state) => state.isLoading);
    const loadingText = useLoadingStore((state) => state.loadingText);
    const { startLoading, stopLoading } = useLoadingStore((state) => state.actions);

    return {
        isLoading,
        loadingText,
        startLoading,
        stopLoading,
    };
};